export const LOADING_START = "LOADING_START";
export const LOADING_STOP = "LOADING_STOP";
export const AUTH_FAIL = "AUTH_FAIL";
